import { useState, useEffect } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import About from "../components/About";
// import OurFocus from "../components/OurFocus";
import PoweringTomorrow from "../components/PoweringTomorrow";
import Vision from "../components/Vision";
import Principles from "../components/Principles";
import CleanElectricity from "../components/CleanElectricity";
import Directors from "../components/Directors";
import CityMission from "../components/CityMission";
// import AboutEleven from "../components/AboutEleven";
import Petition from "../components/Petition";
// import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import DecorativeCurves from "../components/DecorativeCurves";
import { trackPageView } from "../utils/mixpanel";

function Home() {
  const [showFullLogo, setShowFullLogo] = useState(false);

  useEffect(() => {
    trackPageView("Home");
  }, []);

  const handleScrollProgress = (progress) => {
    setShowFullLogo(progress >= 1);
  };

  return (
    <div className="App">
      <DecorativeCurves />
      <Header showFullLogo={showFullLogo} />
      <Hero onScrollProgress={handleScrollProgress} />
      <About />
      {/* <OurFocus /> */}
      <Vision />
      <PoweringTomorrow />
      <Principles />
      <CleanElectricity />
      <Directors />
      <CityMission />
      {/* <AboutEleven /> */}
      <Petition />
      {/* <FAQ /> */}
      <Footer />
    </div>
  );
}

export default Home;
